module.exports = __webpack_public_path__ + "img/DEBI-Gold.97324d0b.png";